<template>
  <div class="pay_cont quickaccounttransfer target_quickaccounttransfer">
    <div class="quick_account_cont" id="quick_account1_cont">
      <div class="row card-method" v-if="!financeName">
        <div class="payment-item-a-btn">
          <button
            type="button"
            class="bt-akl-white basic st2"
            @click="requestBillingAuth"
          >
            퀵계좌 등록
          </button>
        </div>
      </div>
      <div class="row card-method" v-if="financeName">
        <div class="payment-item-a-btn">
          <div class="payment-item-title-bar">
            <span class="payment-item-title">퀵계좌</span>
            <span class="payment-item-title">{{ financeName }}</span>
          </div>
          <button
            type="button"
            class="bt-akl-white basic st2"
            @click="requestBillingAuth"
          >
            퀵계좌 변경
          </button>
        </div>
      </div>
    </div>
    <modal-alert ref="refAlert" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { log } from "@/utils/common";
import ModalAlert from "@/components/global/ModalAlert";
import orderApi from "@/apis/order";
import {
  BILLING_PAYMENT_MODE,
  QUICK_ACCOUNT_PAYMENT_TYPE,
  AMWAY_PAY_METHODS,
} from "@/utils/constants";

export default {
  name: "QuickAccountBilling",
  components: {
    ModalAlert,
  },
  props: {},
  data() {
    return {
      isMobile: "ontouchstart" in document.documentElement,
      billingConfig: {},
      resultData: null,
    };
  },
  async mounted() {
    this.loadTossPaymentScript();
    this.fetchBillingConfig();

    const { paymentMode, paymentCode, customerId, issuerCode, issuerName } =
      this.paymentInfo;

    if (paymentMode == AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
      // billingkey response
      const uuid = this.$route.query.uuid;
      if (uuid) {
        // console.log("response : " + this.$route.path);

        // this.$router.replace(this.$route.path);
        // const savedState = sessionStorage.getItem('vuex');
        // if (savedState) {
        //   this.$store.replaceState(JSON.parse(savedState));
        //   sessionStorage.removeItem('vuex');
        // }
        log("Billing uuid : ", uuid);
        this.$router.replace(this.$route.path);
        const resultData = await orderApi.getBillingKeyInfo(uuid);
        // 결과값 반환
        this.saveBillingKeyData(resultData);
      } else {
        this.setQuickAccountBillingInfo({
          billingKey: paymentCode,
          financeCode: issuerCode,
          financeName: issuerName,
          customerKey: customerId,
        });
      }
    }

    // const paymentInfo = this.paymentInfo;
    // const paymentMode = paymentInfo.paymentMode;
    // const paymentCode = paymentInfo.paymentCode;

    // console.log("mounted QuickAccount");

    // if (paymentMode == AMWAY_PAY_METHODS.QUICK_ACCOUNT) {
    //   if (!!paymentCode) {
    //     // let index = -1;
    //     // index = this.amwayPayAccounts.masterParty.findIndex(
    //     //   (account) => account.methodKey == paymentCode
    //     // );
    //     // if (index > -1) {
    //     //   this.activeIndex = index;
    //     //   this.$store.commit("amwaypay/updateSelectedParty", 0);
    //     //   return;
    //     // }

    //     // index = this.amwayPayAccounts.subParty.findIndex(
    //     //   (account) => account.methodKey == paymentCode
    //     // );

    //     // if (index > -1) {
    //     //   this.activeIndex = index;
    //     //   this.$store.commit("amwaypay/updateSelectedParty", 1);
    //     //   return;
    //     // }

    //     // if (index == -1) {
    //     //   this.$store.commit("amwaypay/resetAmwayPay");
    //     // }
    //   }
    // }
  },
  computed: {
    ...mapGetters({
      paymentInfo: "payment/paymentInfo",
    }),
    financeName() {
      return this.resultData && this.resultData.financeName;
    },
  },
  methods: {
    async loadTossPaymentScript() {
      const script = document.createElement("script");
      script.src = "https://js.tosspayments.com/v1/payment";
      script.onload = () => {
        log("tosspayments::load js");
      };
      document.head.appendChild(script);
    },
    async fetchBillingConfig() {
      const params = {
        payment_mode: BILLING_PAYMENT_MODE.QUICK_ACCOUNT,
        payment_type: QUICK_ACCOUNT_PAYMENT_TYPE.BILLING,
      };
      const result = await orderApi.getPaymentConfig(params);
      if (result.error) {
        return;
      }
      this.billingConfig = result;
    },
    requestBillingAuth() {
      const clientKey = this.billingConfig["CLIENT_KEY"];
      const customerName = this.billingConfig["CUSTOMER_NAME"];
      const customerKey = this.billingConfig["CUSTOMER_KEY"];

      const tossPayments = TossPayments(clientKey);
      let requestPaymentParam = {
        customerName: customerName,
        customerKey: customerKey,
      };

      let returnUrl = `${process.env.API_BASE_URL}/billing-key/receive/${
        this.isMobile ? "mobile" : "desktop"
      }`;
      requestPaymentParam.successUrl = returnUrl;
      requestPaymentParam.failUrl = returnUrl;

      const vm = this;
      let catchFunction = function (error) {
        if (error.code === "USER_CANCEL") {
          // 구매자가 결제창을 닫았을 때 에러 처리
        } else if (error.code === "INVALID_CARD_COMPANY") {
          // 유효하지 않은 카드 코드에 대한 에러 처리
        } else {
          vm.$refs.refAlert.openWithMessage(error.message);
        }
      };

      sessionStorage.setItem("billingCallbackUrl", window.location.href);

      // store 저장
      const stateCopy = { ...this.$store.state };
      delete stateCopy.appReadyState; // appReadyState 제외
      sessionStorage.setItem("save-vuex", JSON.stringify(stateCopy));

      this.$emit("save-data");

      tossPayments
        .requestBillingAuth("계좌이체", requestPaymentParam)
        .catch(catchFunction);
    },
    saveBillingKeyData(resultData) {
      // 정상적으로 빌링키를 발급받았을 경우
      if (resultData.respCode == "0000") {
        this.setQuickAccountBillingInfo(resultData);
        this.$refs.refAlert.openWithMessage("결제정보가 입력되었습니다.");
        return;
      }
      // 오류 발생 시 받은 결과 메시지를 노출
      else if (resultData && resultData.respMsg) {
        this.$refs.refAlert.openWithMessage(resultData.respMsg);
      }
    },
    setQuickAccountBillingInfo(resultData) {
      this.resultData = resultData;
      this.$store.commit(
        "quickaccountbilling/setQuickAccountBillingInfo",
        resultData
      );
    },
  },
};
</script>

<style scoped>
</style>
